import { render, staticRenderFns } from "./Option.vue?vue&type=template&id=5f49a23a&"
import script from "./Option.vue?vue&type=script&lang=ts&"
export * from "./Option.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-cfm/mfe-cfm/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f49a23a')) {
      api.createRecord('5f49a23a', component.options)
    } else {
      api.reload('5f49a23a', component.options)
    }
    module.hot.accept("./Option.vue?vue&type=template&id=5f49a23a&", function () {
      api.rerender('5f49a23a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wizard/Ivr/Option.vue"
export default component.exports